import axios from '@/plugins/axios'
import moment from "moment"


export default {
    methods: {
        refreshData() {
            this.loading = true
            Promise.all([
                this.GetListingPoints(),
            ]).finally(() => {
                this.loading = false
            });
        },
        refreshDemand() {
            this.loading = true
            Promise.all([
                this.GetNbBookings(),
                this.GetOvernights(),
                this.GetOvernights(),
                this.GetLOfStay(),
                this.GetOccupation(),
                this.GetEvo12Months(),
                this.GetObjectsAvailability(),
                this.GetObjectsRentalActivity()
            ]).finally(() => {
                this.loading = false
            });
        },
        refreshRevenues() {
            this.loading = true
            console.log("load revenues");
            Promise.all([
                this.GetRevenueKPIs(),
                this.GetRevenuesEvo12Months()
            ]).finally(() => {
                this.loading = false
            });
        },
        getRoomTypeColors(room_type) {
            switch (room_type) {
                case "Logement entier":
                case "Entire home/apt":
                case "Gesamte Unterkunft":
                default:
                    return "#3498db";
                case "Chambre privée":
                case "Private room":
                case "Privatzimmer":
                    return "#e74c3c";
                case "Chambre partagée":
                case "Shared room":
                case "Gemeinsames Zimmer":
                    return "#f1c40f";
                case "Chambre d'hôtel":
                case "Hotel room":
                case "Hotel Zimmer":
                    return "#7befb2";
            }
        },
        async GetListingPoints() {
            await axios
                .post("AirDNA/GetListingsPoints", {
                    month_min: moment(this.params.monthrange[0], 'MM-DD-YYYY').endOf('m').format("MM-DD-YYYY"),
                    month_max: moment(this.params.monthrange[1], 'MM-DD-YYYY').format("MM-DD-YYYY"),
                    platform: this.params.platform,
                    language: this.$i18n.locale,
                    regions: this.params.region.map((r) => r.value),
                    canton: 11
                })
                .then((res) => {
                    // set map data
                    this.map.data = res.data;

                    // variables for storing graph data
                    let objectsType = new Object();
                    let objectsSize = new Object();
                    let priceType = new Object();
                    let priceSize = new Object();

                    // pass through each object
                    res.data.forEach((item) => {
                        var guests = item.max_guests >= 10 ?
                            "10+" :
                            item.max_guests.toString();

                        // objects by type
                        if (item.type in objectsType) {
                            objectsType[item.type] += 1;
                        }
                        else {
                            objectsType[item.type] = 1;
                        }

                        // objects by size
                        if (guests in objectsSize) {
                            objectsSize[guests] += 1;
                        }
                        else {
                            objectsSize[guests] = 1;
                        }

                        // price by type
                        if (item.type in priceType) {
                            priceType[item.type] += item.adr;
                        }
                        else {
                            priceType[item.type] = item.adr;
                        }

                        // price by Size
                        if (guests in priceSize) {
                            priceSize[guests] += item.adr;
                        }
                        else {
                            priceSize[guests] = item.adr;
                        }
                    });

                    // objects by type
                    var objTypeGraph = new Array();
                    var objTypeLabels = new Array();

                    for (let key in objectsType) {
                        objTypeGraph.push(objectsType[key]);
                        objTypeLabels.push(key);
                    }

                    this.objectsByType.data[0].data = objTypeGraph;
                    this.objectsByType.chartOptions.xaxis.categories = objTypeLabels;

                    // adr by type
                    var adrTypeGraph = new Array();
                    var adrTypeLabels = new Array();

                    for (let key in priceType) {
                        adrTypeGraph.push(priceType[key] / objectsType[key]);
                        adrTypeLabels.push(key);
                    }

                    this.adrByType.data[0].data = adrTypeGraph;
                    this.adrByType.chartOptions.xaxis.categories = adrTypeLabels;

                    // objects by size
                    var objSizeGraph = new Array();
                    var objSizeLabels = new Array();
                    for (let key in objectsSize) {
                        objSizeGraph.push(objectsSize[key]);
                        objSizeLabels.push(key);
                    }

                    this.objectsBySize.data[0].data = objSizeGraph;
                    this.objectsBySize.chartOptions.xaxis.categories = objSizeLabels;

                    // adr by Size
                    var adrSizeGraph = new Array();
                    var adrSizeLabels = new Array();
                    for (let key in priceSize) {
                        adrSizeGraph.push(priceSize[key] / objectsSize[key]);
                        adrSizeLabels.push(key);
                    }

                    this.adrBySize.data[0].data = adrSizeGraph;
                    this.adrBySize.chartOptions.xaxis.categories = adrSizeLabels;
                });
        },
        async GetNbBookings() {
            await axios
                .post("AirDNA/GetBookings", {
                    month_min: moment(this.params.monthrange[0], 'MM-DD-YYYY').endOf('m').format("MM-DD-YYYY"),
                    month_max: moment(this.params.monthrange[1], 'MM-DD-YYYY').format("MM-DD-YYYY"),
                    platform: this.params.platform,
                    regions: this.params.region.map((r) => r.value),
                    canton: 11
                })
                .then((res) => {
                    // compute evolutions
                    let actualBookings = res.data[0];
                    let previousBookings = res.data[1];
                    let bookingsEvoPerc = actualBookings / previousBookings - 1;
                    let bookingsEvoReal = actualBookings - previousBookings;

                    // pass values to view
                    this.kpis.bookings.actualBookings = actualBookings;
                    this.kpis.bookings.bookingsEvoPerc = bookingsEvoPerc;
                    this.kpis.bookings.bookingsEvoReal = bookingsEvoReal;
                });
        },
        async GetOvernights() {
            await axios
                .post("AirDNA/GetOvernights", {
                    month_min: moment(this.params.monthrange[0], 'MM-DD-YYYY').endOf('m').format("MM-DD-YYYY"),
                    month_max: moment(this.params.monthrange[1], 'MM-DD-YYYY').format("MM-DD-YYYY"),
                    platform: this.params.platform,
                    regions: this.params.region.map((r) => r.value),
                    canton: 11,
                })
                .then((res) => {
                    // compute evolutions
                    let actualOvernights = res.data[0];
                    let previousOvernights = res.data[1];
                    let overnightsEvoPerc = actualOvernights / previousOvernights - 1;
                    let overnightsEvoReal = actualOvernights - previousOvernights;

                    // pass values to view
                    this.kpis.overnights.actualOvernights = actualOvernights;
                    this.kpis.overnights.overnightsEvoPerc = overnightsEvoPerc;
                    this.kpis.overnights.overnightsEvoReal = overnightsEvoReal;
                });
        },
        async GetLOfStay() {
            await axios
                .post("AirDNA/GetAvgLOfStay", {
                    month_min: moment(this.params.monthrange[0], 'MM-DD-YYYY').endOf('m').format("MM-DD-YYYY"),
                    month_max: moment(this.params.monthrange[1], 'MM-DD-YYYY').format("MM-DD-YYYY"),
                    platform: this.params.platform,
                    regions: this.params.region.map((r) => r.value),
                    canton: 11,
                })
                .then((res) => {
                    // compute evolutions
                    let actualLOfStay = res.data[0];
                    let previousLOfStay = res.data[1];
                    let lOfStayEvoPerc = actualLOfStay / previousLOfStay - 1;
                    let lOfStayEvoReal = actualLOfStay - previousLOfStay;

                    // pass values to view
                    this.kpis.lOfStay.actuallOfStay = actualLOfStay;
                    this.kpis.lOfStay.lOfStayEvoPerc = lOfStayEvoPerc;
                    this.kpis.lOfStay.lOfStayEvoReal = lOfStayEvoReal;
                });
        },
        async GetOccupation() {
            await axios
                .post("AirDNA/GetMedianOccupation", {
                    month_min: moment(this.params.monthrange[0], 'MM-DD-YYYY').endOf('m').format("MM-DD-YYYY"),
                    month_max: moment(this.params.monthrange[1], 'MM-DD-YYYY').format("MM-DD-YYYY"),
                    platform: this.params.platform,
                    regions: this.params.region.map((r) => r.value),
                    canton: 11,
                })
                .then((res) => {
                    // compute evolutions
                    let actualOccupation = res.data.Occupation;
                    let previousOccupation = res.data.OccupationPrev;
                    let occupationEvoPerc = actualOccupation / previousOccupation - 1;
                    let occupationEvoReal = actualOccupation - previousOccupation;

                    // pass values to view
                    this.kpis.occupation.actualOccupation = actualOccupation;
                    this.kpis.occupation.occupationEvoPerc = occupationEvoPerc;
                    this.kpis.occupation.occupationEvoReal = occupationEvoReal;
                });
        },
        async GetEvo12Months() {
            await axios
                .post(
                    "AirDNA/GetMonthlyIndicators",
                    {
                        month_max: moment(this.params.monthrange[1], 'MM-DD-YYYY').endOf('month').format("MM-DD-YYYY"),
                        month_min: moment(this.params.monthrange[1], 'MM-DD-YYYY').endOf('month').subtract(1, 'y').add(1, 'd').format("MM-DD-YYYY"),
                        platform: this.params.platform,
                        regions: this.params.region.map((r) => r.value),
                        canton: 11,
                    }
                )
                .then((res) => {
                    var data = res.data;

                    //this.evolutionChart.data = data;
                    var legend = new Array();
                    var serieAct = new Array();
                    var seriePrev = new Array();
                    var serieEvo = new Array();

                    data.forEach(function (item) {
                        legend.push(item.month + "." + item.year);
                        serieAct.push(item.overnights);
                        seriePrev.push(item.previousOvernights);
                        serieEvo.push(
                            parseFloat(item.bookings) / parseFloat(item.previousBookings) - 1
                        );
                    });

                    this.evolutionChart.options.xaxis.categories = legend;
                    this.evolutionChart.data[0].data = serieAct;
                    this.evolutionChart.data[1].data = seriePrev;
                    this.overYearChart.options.xaxis.categories = legend;
                    this.overYearChart.data[0].data = serieEvo;
                });
        },
        async GetObjectsAvailability() {
            await axios
                .post(
                    "AirDNA/GetAvailableDays",
                    {
                        month_max: moment(this.params.monthrange[0], 'MM-DD-YYYY').endOf('m').format("MM-DD-YYYY"),
                        month_min: moment(this.params.monthrange[0], 'MM-DD-YYYY').endOf('m').subtract(1, 'y').add(1, 'd').format("MM-DD-YYYY"),
                        platform: this.params.platform,
                        regions: this.params.region.map((r) => r.value),
                        canton: 11,
                    }
                )
                .then((res) => {
                    var labels = new Array();
                    var values = new Array();

                    // foreach entry in data
                    res.data.forEach((item) => {
                        labels.push(item.Key);
                        values.push(item.Value);
                    });

                    this.objectsAvailability.data = values;
                    this.objectsAvailability.chartOptions.labels = labels;
                });
        },
        async GetObjectsRentalActivity() {
            await axios
                .post(
                    "AirDNA/GetRentedDays",
                    {
                        month_max: moment(this.params.monthrange[0], 'MM-DD-YYYY').endOf('month').format("MM-DD-YYYY"),
                        month_min: moment(this.params.monthrange[0], 'MM-DD-YYYY').endOf('month').subtract(1, 'y').add(1, 'd').format("MM-DD-YYYY"),
                        platform: this.params.platform,
                        regions: this.params.region.map((r) => r.value),
                        canton: 11,
                    }
                )
                .then((res) => {
                    var labels = new Array();
                    var values = new Array();

                    // foreach entry in data
                    res.data.forEach((item) => {
                        labels.push(item.Key);
                        values.push(item.Value);
                    });

                    this.rentalActivity.data = values;
                    this.rentalActivity.chartOptions.labels = labels;
                });
        },
        async GetRevenueKPIs() {
            await axios
                .post(
                    "AirDNA/GetRevenueKPIs",
                    {
                        month_max: moment(this.params.monthrange[1], 'MM-DD-YYYY').format("MM-DD-YYYY"),
                        month_min: moment(this.params.monthrange[0], 'MM-DD-YYYY').endOf('m').format("MM-DD-YYYY"),
                        platform: this.params.platform,
                        regions: this.params.region.map((r) => r.value),
                        canton: 11,
                    }
                )
                .then((res) => {
                    // Revenues
                    let revenue = res.data.revenue * res.data.dollar;
                    let revenue_prev = res.data.previousRevenue * res.data.previousDollar;
                    let objects = res.data.objects;
                    let objects_prev = res.data.objectsPrevious;
                    let revenueEvoPerc = revenue / revenue_prev - 1;
                    let revenueEvoReal = revenue - revenue_prev;

                    this.kpis.totalRevenues.actualRevenues = revenue;
                    this.kpis.totalRevenues.revenuesEvoPerc = revenueEvoPerc;
                    this.kpis.totalRevenues.revenuesEvoReal = revenueEvoReal;

                    // daily revenue
                    let days = moment(this.params.monthrange[1]).endOf('month').
                        diff(moment(this.params.monthrange[0]).endOf('m').startOf('month'), 'days');
                    let daysPrevious = moment(this.params.monthrange[1]).subtract(1, 'y').endOf('month').
                        diff(moment(this.params.monthrange[0]).endOf('m').subtract(1, 'y').startOf('month'), 'days');
                    let dailyRevenue = revenue / days / objects;
                    let previousDailyRevenu = revenue_prev / daysPrevious / objects_prev;
                    let dailyRevenueEvoPerc = dailyRevenue / previousDailyRevenu - 1;
                    let dailyRevenueEvoReal = dailyRevenue - previousDailyRevenu;

                    this.kpis.dailyObjectRevenue.actualDailyRevenue = dailyRevenue;
                    this.kpis.dailyObjectRevenue.dailyRevenuEvoPerc = dailyRevenueEvoPerc;
                    this.kpis.dailyObjectRevenue.dailyRevenuEvoReal = dailyRevenueEvoReal;

                    // revenues by rooms
                    let occpancy = res.data.max_guests;
                    let occupancy_prev = res.data.max_guestsPrevious;
                    let roomsRevenue = revenue / occpancy;
                    let previousRoomsRevenue = revenue_prev / occupancy_prev;
                    let roomsRevenueEvoPerc = roomsRevenue / previousRoomsRevenue - 1;
                    let roomsRevenueEvoReal = roomsRevenue / previousRoomsRevenue - 1;

                    this.kpis.capacityRevenue.actualCapacityRevenue = roomsRevenue;
                    this.kpis.capacityRevenue.capacityRevenueEvoPerc = roomsRevenueEvoPerc;
                    this.kpis.capacityRevenue.capacityRevenueEvoReal = roomsRevenueEvoReal;
                });
        },
        async GetRevenuesEvo12Months() {
            await axios
                .post(
                    "AirDNA/GetMonthlyRevenues",
                    {
                        month_max: moment(this.params.monthrange[1], 'MM-DD-YYYY').endOf('month').format("MM-DD-YYYY"),
                        month_min: moment(this.params.monthrange[1], 'MM-DD-YYYY').endOf('month').subtract(1, 'y').add(1, 'd').format("MM-DD-YYYY"),
                        platform: this.params.platform,
                        regions: this.params.region.map((r) => r.value),
                        canton: 11,
                    }
                )
                .then((res) => {
                    var data = res.data;

                    //this.evolutionChart.data = data;
                    var legend = new Array();
                    var serieAct = new Array();
                    var seriePrev = new Array();
                    var serieEvo = new Array();

                    data.forEach(function (item) {
                        let revenue = item.revenue * item.dollar_value;
                        let prevRevenue = item.previousRevenue * item.previousDollar
                        legend.push(item.month + "." + item.year);
                        serieAct.push(revenue);
                        seriePrev.push(prevRevenue);
                        serieEvo.push(
                            parseFloat(revenue) / parseFloat(prevRevenue) - 1
                        );
                    });

                    this.evolutionChart.options.xaxis.categories = legend;
                    this.evolutionChart.data[0].data = serieAct;
                    this.evolutionChart.data[1].data = seriePrev;
                    this.overYearChart.options.xaxis.categories = legend;
                    this.overYearChart.data[0].data = serieEvo;
                });
        },
    }
}